import { Box, Tabs, Tab } from '@mui/material'
import PlanItem from './PlanItem'

const PlanSelectionContent = ({
  selectedFrequency,
  onFrequencyChange,
  availablePlans,
  selectedPlanId,
  onPlanSelect,
  errorMessage,
  showFilteredPlans = false,
  onShowAllPlans
}) => (
  <>
    <div className='py-4'>
      {showFilteredPlans && onShowAllPlans && (
        <div className='flex justify-end mb-3'>
          <button
            type='button'
            onClick={onShowAllPlans}
            className='text-sm text-accent2 hover:underline font-medium'
          >
            Ver todo
          </button>
        </div>
      )}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={selectedFrequency}
          onChange={onFrequencyChange}
          centered
          sx={{
            '& .MuiTab-root': { textTransform: 'none', fontSize: '1rem', fontWeight: 500 },
            '& .Mui-selected': { color: '#6366f1', fontWeight: 600 },
            '& .MuiTabs-indicator': { backgroundColor: '#6366f1' }
          }}
        >
          <Tab label="Mensual" value="monthly" />
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>Anual</span>
                <span className="bg-green-500 text-white text-xs px-2 py-0.5 rounded-full font-semibold">
                  2 meses gratis
                </span>
              </Box>
            }
            value="yearly"
          />
        </Tabs>
      </Box>

      {selectedFrequency === 'yearly' && (
        <div className='bg-green-50 border border-green-200 rounded-lg p-3 mb-4'>
          <p className='text-sm text-green-800 text-center'>
            <strong>¡Ahorra con el plan anual!</strong> Al contratar un plan anual, obtienes 2 meses de regalo.
          </p>
        </div>
      )}

      {availablePlans.length === 0 ? (
        <p className="text-gray-600 text-center py-8">No hay planes disponibles para esta frecuencia</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {availablePlans.map((plan) => (
            <PlanItem
              key={plan.id}
              plan={plan}
              isSelected={false}
              isSelectedForUpdate={plan.id === selectedPlanId}
              onSelect={onPlanSelect}
            />
          ))}
        </div>
      )}

      {errorMessage && (
        <div className='mt-4 text-red-600 text-sm text-center'>{errorMessage}</div>
      )}
    </div>
  </>
)

export default PlanSelectionContent
